"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("./colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  IconButton: {},
  iconbuttons: {
    "default": {
      color: _colors["default"].neutral[300],
      '&:hover': {
        backgroundColor: _colors["default"].neutral[200],
        color: _colors["default"].neutral[500]
      },
      '&:active': {
        backgroundColor: _colors["default"].neutral[300],
        color: _colors["default"].neutral[500]
      }
    },
    danger: {
      color: _colors["default"].red[300],
      '&:hover': {
        color: _colors["default"].red[500],
        backgroundColor: _colors["default"].red[200]
      },
      '&:active': {
        color: _colors["default"].red[500],
        backgroundColor: _colors["default"].red[300]
      }
    },
    warn: {
      color: _colors["default"].yellow[300],
      '&:hover': {
        color: _colors["default"].yellow[500],
        backgroundColor: _colors["default"].yellow[200]
      },
      '&:active': {
        color: _colors["default"].yellow[500],
        backgroundColor: _colors["default"].yellow[300]
      }
    },
    primary: {
      color: _colors["default"].teal[300],
      '&:hover': {
        color: _colors["default"].teal[500],
        backgroundColor: _colors["default"].teal[200]
      },
      '&:active': {
        color: _colors["default"].teal[500],
        backgroundColor: _colors["default"].teal[300]
      }
    }
  }
};
exports["default"] = _default;